import { InitConfigService } from '@bcone/neo-app-sdk';
import { environment } from 'src/environments/environment';
var data = environment;
var ɵ0 = function (config) { return function () { return config.load(); }; };
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };
